import type { Role } from '@/lib/auth-context';
import { fetchApi } from '@/services/api-client';

export const PRESENCE_PATH = '/admin/presence';

export type PresenceUser = {
  userId: string;
  displayName: string;
  nickname: string | null;
  photoUrl: string;
  role: Role;
  /** ISO timestamp of when this user's current session began. */
  connectedAt: string;
};

export const presenceApi = {
  getAll: () => fetchApi<PresenceUser[]>(PRESENCE_PATH),
};
